import { useGetWatermark } from "@/shared";

const Watermark = () => {
  const watermark = useGetWatermark();
  if (!watermark?.active) return null;
  const { color, opacity, content } = watermark;

  return (
    <div className="tw-pointer-events-none tw-absolute tw-inset-0 tw-z-[99] tw-flex tw-size-full tw-select-none tw-items-center tw-justify-center tw-overflow-hidden">
      <span
        className="tw-origin-center -tw-rotate-45 tw-font-sans tw-text-4xl/none tw-font-extrabold tw-uppercase md:tw-text-[64px]/none"
        style={{
          color,
          opacity: opacity / 100,
        }}
      >
        {content}
      </span>
    </div>
  );
};

export default Watermark;
